// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { v4 as uuidv4 } from 'uuid';
import { InstrumentIdentifier } from '@daml.js/utility-registry-holding-v0/lib/Utility/Registry/Holding/V0/Types';

export interface InstrumentIdentifierElement {
  id: string;
  element: InstrumentIdentifier;
}
export const toInstrumentIdentifiers = (elems: InstrumentIdentifierElement[]) => {
  return elems.map(({ element }) => ({
    source: element.source,
    id: element.id,
    scheme: element.scheme,
  }));
};

export const fromInstrumentIdentifiers = (elems: InstrumentIdentifier[]) => {
  return elems.map((element) => ({
    id: uuidv4(), // Generate unique ID for each element
    element,
  }));
};
